/**
 * @file Shell of the multi-part Signify fetch modal, the sibling of `SignifyProductModal` that
 * stages many parts and fetches none until Start. Consumer: `ArTableControls`, which mounts it
 * beside the single-part modal and the configuration sidebar.
 * The shell owns nothing but `open`: it is never gated on mount, so antd keeps its close
 * transition, and `destroyOnHidden` unmounts `SignifyFetchJobModalContent` — with it the per-mount
 * draft proxy and the distributor and search state a closed modal has no business holding.
 * `mask.closable` is off because a stray click outside would discard a list of hundreds of parts.
 */

import { FC } from 'react';
import { Modal } from 'antd';
import SignifyFetchJobModalContent from './components/SignifyFetchJobModalContent';
import { SignifyFetchJobModalProps } from './index.types';

const SIGNIFY_FETCH_JOB_MODAL_WIDTH = 1000;

const SignifyFetchJobModal: FC<SignifyFetchJobModalProps> = ({ open, onCancel, ...content }) => {
  return (
    <Modal
      title="Add Parts List From Signify"
      open={open}
      onCancel={onCancel}
      width={SIGNIFY_FETCH_JOB_MODAL_WIDTH}
      mask={{ closable: false }}
      destroyOnHidden
      footer={null}
    >
      <SignifyFetchJobModalContent {...content} />
    </Modal>
  );
};

export default SignifyFetchJobModal;
